module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'succès',
    selected: 'Sélectionné',
    chooseGiftFirst: 'Veuillez d’abord choisir une carte cadeau : Apple ou Starbucks.',
    综合评价: "Évaluation Globale",
    inputNotSame: "Entrée Non Identique",
    exemple: 'Exemple',
    "btnPrev": "Précédent",
    // 选择语言
    popupTitle: 'Sélectionner une langue',
    // 发送
    send: 'Confirmer',
    // 发送邮件
    sendEmail: 'Envoyer un e-mail',
    // 改变语言
    changeLanSes: 'Changement de langue réussi',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 系统标题
    title: `La voix de l'acheteur`,
    // 系统解释
    details: 'À l’écoute des acheteurs, nous proposons des produits et services de qualité.\nMerci de nous accompagner !',
    fileSizeOver: "Le fichier est trop volumineux, seules les images de moins de 10 Mo sont prises en charge.",
    lowTextarea: 'Vos commentaires nous aideront à améliorer continuellement nos produits et services.',
    placeholderOrderNo: "Veuillez saisir le numéro de commande (format : 000-0000000-0000000)",
    "picUploadSuccessText": "Image téléchargée avec succès",
    "picUploadErrorText": "Échec du téléchargement de l'image",
    "orderNotExistText": "La commande n'existe pas",
    "orderInvalidText": "Cette commande est invalide",
    "networkErrorText": "Erreur réseau",
    "orderErrorText": "Erreur de commande",
    // step1
    formBasic: {
        confirm_btn: "Valider",
        "order_help_title": "Aide au numéro de commande",
    "order_help_content": "Si vous ne connaissez pas votre numéro de commande, veuillez nous contacter pour savoir comment l'obtenir. Notre e-mail : ",
         form_code: 'Code de vérification',
        form_code_placeholder: 'Veuillez saisir le code de vérification',
        "get_code": "Obtenir le code",
  "code_sent_success": "Code envoyé avec succès",
        title: 'Enregistrez votre garantie et<br><span style="color:#C9A127">réclamez votre cadeau mystère</span>',
        form_name: 'Name',
        form_email: 'Courriel',
        form_email_note: 'pour la livraison du cadeau et l’assistance',
        form_order: 'Numéro de commande',
        form_order_error_placeholder: 'Veuillez saisir le numéro de commande (format : 000-0000000-0000000)',
        order_why: '*Comment trouver votre numéro de commande?',
        platform_name: "Nom de la plateforme",
        "platform_name_placeholder": "Veuillez sélectionner une plateforme",
        order_answer: `*Nous ne partageons pas vos informations personnelles avec qui que ce soit.

Vos informations personnelles sont sécurisées et utilisées uniquement pour l'activation de votre garantie.`,
        btn_text: 'Activer maintenant',
        "form_name_placeholder": "Veuillez entrer votre nom",
        "form_email_placeholder": "Veuillez entrer votre Courriel",
        "form_email_error_placeholder": "Veuillez entrer un Courriel",
        "form_order_placeholder": "Veuillez entrer votre numéro de ID commande"
    },
    // step2
    showGiftCard: {
        title: 'Votre garantie prolongée est activée.<br>Nous avons ajouté <strong>9 mois</strong> de couverture à votre produit.<br>Merci pour votre achat !',
        text: '🎁 Réclamez votre carte-cadeau de 20 $ et partagez votre expérience<br><small>(Moins d’une minute)</small>',
        gift_card_text: 'Choisissez votre carte-cadeau électronique de 20 $',
        btn_text: 'Obtenir ma récompense'
    },
    // step3
    expectations: {
        title: "Merci d'avoir choisi nos produits et services !",
        text: "S'il répond à vos attentes ou vous apporte une petite surprise, pourquoi ne pas prendre quelques secondes pour laisser un avis positif sur le site d'achat ? Laissez un avis positif et recevez une carte-cadeau de 10 $ !",
        btn_text: "Étape suivante"
    },
    // step3
    star: {
        title: 'Êtes-vous satisfait de ce produit ou de notre service ?',
        text: 'Veuillez attribuer une note en étoiles au produit ci-dessous:',
        star__placeholder: 'Veuillez évaluer toutes les questions avant de soumettre !',
        written: 'Ajouter un avis écrit : <span style="color:#F40000">(Optionnel)</span>',
        written_placeholder: `Qu'avez-vous aimé ? À quoi avez-vous utilisé ce produit ?`,
        btn_text: 'Étape suivante'
    },
    // step4
    ensureEmail: {
        title: `Félicitations!</br>
Vous avez terminé l'enquête.
`,
        text: `Veuillez confirmer l'adresse e-mail, vous recevrez le code cadeau par l'intermédiaire de cette adresse e-mail :
customerservice8@yeah.net`,
        email_placeholder: `Veuillez confirmer à nouveau l'email !`,
        btn_text: 'Confirmer'
    },
    // step5
    reviewGuide: {
        title: 'Comment laisser un avis sur votre plateforme d’achat',
        subtitle: 'Sélectionnez votre plateforme pour voir les étapes.'
    },
    channelSelect: {
        title: `Votre avis compte ! `,
        text: `Merci d'avoir partagé votre précieux avis ! Vous pouvez maintenant choisir le cadeau de votre choix !!!`,
        footer: `*A propos du cadeau :</br> 
Pas de frais d'expédition, pas de frais cachés, pas de carte de crédit requise.`,
        btn_text: 'Je le veux'
    },
    // step6
    uploadPic: {
        guideText: 'Besoin d’aide pour faire une capture d’écran ?<br><small>Sélectionnez votre plateforme d’achat ci-dessous pour consulter un guide rapide.</small>',
        "title": "Veuillez télécharger une capture d’écran de votre expérience avec le produit.",
  "text": "Pour obtenir votre carte-cadeau de 20 $, envoyez simplement ci-dessous une capture d’écran<br>de votre avis publié.",
        add_pic: 'Cliquez pour importer ou glissez-déposez',
        add_pic_text: 'JPG / PNG, jusqu’à 10 Mo',
        btn_text: 'Envoyer et réclamer le cadeau',
        uploading: 'Téléchargement... Veuillez patienter',
        upload_required: 'Veuillez importer une capture d’écran avant de continuer.',
       "no_file_selected": "Aucun fichier sélectionné"
    },
    // step7
    cityForm: {
        title: '*Adresse de réception des accessoires : ',
        text: '(Veuillez confirmer votre adresse de livraison, le cadeau sera expédié dans les 3 à 5 jours ouvrables.)',
        form_city: 'Ville',
        form_state: 'État/Région',
        form_postal_code: 'Code postal',
        form_country: 'Pays',
        btn_text: 'Confirmez',
        "form_city_placeholder": "Veuillez entrer votre ville",
        "form_state_placeholder": "Veuillez entrer votre région",
        "form_postal_code_placeholder": "Veuillez entrer votre code postal",
        "form_country_placeholder": "Veuillez entrer votre pays"
    },
    // step7
    paypalForm: {
        title: 'Où devons-nous envoyer votre carte-cadeau de 20 $ ?',
        text: '(Veuillez vérifier l’exactitude de vos informations PayPal pour éviter tout retard.)',
        form_paypal: 'Compte PayPal',
        form_ensure_paypal: 'Confirmer le compte PayPal',
        form_paypal_name: 'Nom du titulaire du compte PayPal',
        btn_text: 'Confirmer',
        "form_paypal_placeholder": "Veuillez entrer votre compte PayPal",
        "form_ensure_paypal_placeholder": "Veuillez confirmer votre compte PayPal",
        "form_paypal_name_placeholder": "Veuillez entrer votre nom PayPal"
    },
    // thanks-all
    thanksAll: {
        doneTitle: 'C’est terminé ! 🎉', doneDescription: 'Votre capture d’écran a bien été reçue ! Votre demande de carte-cadeau est en cours de traitement.',
        request: 'Demande de carte-cadeau', processing: 'En cours', deliveryPrefix: 'Délai estimé :', deliveryTime: '1-2 jours ouvrés', deliverySuffix: 'par e-mail.',
        rewardTitle: 'Votre récompense', rewardDescription: 'Une carte-cadeau électronique de 20 $ sera envoyée à votre adresse e-mail.',
        verifyStep: 'Nous vérifierons votre capture d’écran sous 1-2 jours ouvrés.', approvedStep: 'Après approbation, votre carte-cadeau vous sera envoyée par e-mail.', spamStep: 'Pensez à vérifier votre dossier spam/indésirables.', supportText: 'Des questions ? Contactez notre équipe d’assistance à l’adresse',
        "title": "Reconnaissant pour votre contribution !",
        // title_desc1: `Merci d'avoir participé à notre enquête sur les produits ! `,
        // title_desc2: 'projector survey!',
        text: `Vos précieuses opinions nous aideront à améliorer la qualité de nos produits. 
Si vous avez des questions pendant l'utilisation, n'hésitez pas à nous contacter.`
    },
    // thanks
    thanks: {
        "title": "Félicitations !",
        title_desc1: `Votre garantie est activée !
Nous vous remercions pour le temps que vous nous avez consacré.`,
        title_default_paypal_desc1: `Votre garantie est activée !
Nous vous remercions pour le temps que vous nous avez consacré. Votre récompense sera émise dans un délai de 24 à 72 heures.`,
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
